<template>
    <div class="page-container">
        <!-- <EquiType @change="handleChangeType" @updateForm="getManufacturerListsData" /> -->
        <div style="flex: 1; min-width: 80%">
            <Transition name="fade">
                <el-form
                    v-if="formVisible"
                    :inline="true"
                    class="search-form"
                    :model="queryForms"
                    label-position="top"
                    style="padding: 0 20px"
                >
                    <el-form-item label="品牌名称">
                        <el-select v-model="queryForms.name" placeholder="请选择品牌名称" clearable>
                            <el-option
                                v-for="item in brandOptionList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="厂家名称">
                        <el-input v-model="queryForms.manufacturer" placeholder="请输入厂家名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                        <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </Transition>
            <el-card class="noBorder" style="flex: 1">
                <div style="display: flex; margin-bottom: 10px">
                    <el-button type="primary" :icon="Plus" @click="onAddClick()" v-permission="['base:brand:add']">
                        添加
                    </el-button>
                    <el-button @click="uploadVisible = true" v-permission="['base:brand:import']">导入</el-button>
                    <el-button @click="handleExport" v-permission="['base:brand:export']">导出</el-button>
                    <div class="card-header" style="margin-left: auto">
                        <div class="circle-btn">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                :content="formVisible ? '隐藏搜索' : '显示搜索'"
                                placement="top"
                            >
                                <el-button
                                    plain
                                    circle
                                    @click="formVisible = !formVisible"
                                    :icon="Search"
                                    size="small"
                                ></el-button>
                            </el-tooltip>
                            <el-tooltip class="box-item" effect="dark" content="刷新" placement="top">
                                <el-button plain circle @click="getTableData" :icon="Refresh" size="small"></el-button>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
                <el-table
                    :data="table_data"
                    border
                    style="width: 100%"
                    v-loading="tableLoading"
                    row-key="id"
                    :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                >
                    <el-table-column label="序号" width="100" type="index" />
                    <el-table-column label="品牌名称" prop="name"></el-table-column>
                    <el-table-column label="品牌编码" prop="code"></el-table-column>
                    <el-table-column label="厂家名称" prop="manufacturer">
                        <template #default="{ row }">
                            <span>{{ row.manufacturer ? row.manufacturer : '无' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="联系电话" width="200" prop="phone">
                        <template #default="{ row }">
                            <span>{{ row.phone ? row.phone : '无' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" prop="remark">
                        <template #default="{ row }">
                            <span v-if="row.remark">{{ row.remark }}</span>
                            <span v-else>无</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="200">
                        <template #default="{ row }">
                            <el-button
                                type="primary"
                                link
                                :icon="View"
                                size="small"
                                @click="onShowClick(row)"
                                v-permission="['base:brand:view']"
                            >
                                详情
                            </el-button>
                            <el-button
                                type="primary"
                                link
                                :icon="Edit"
                                size="small"
                                @click="onEditClick(row)"
                                v-permission="['base:brand:edit']"
                            >
                                编辑
                            </el-button>
                            <el-button
                                type="primary"
                                link
                                :icon="Delete"
                                size="small"
                                @click="onRemoveClick(row)"
                                v-permission="['base:brand:delete']"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination
                    class="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryForms.page"
                    :page-sizes="[10, 20, 50]"
                    :page-size="queryForms.page_size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </el-card>
        </div>
        <forms-dialog
            v-model="formDialogVisible"
            :isForm="isForm"
            :modelId="selectModelId"
            :manufacturerLists="manufacturerLists"
            :manufacturerOptionLists="manufacturerOptionLists"
            @updateForm="getTableData"
        ></forms-dialog>
        <imports-form v-if="uploadVisible" v-model="uploadVisible" @updateForm="getTableData" menuCode="brand"></imports-form>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { Delete, Edit, Plus, Refresh, Search, View } from '@element-plus/icons'
// CirclePlus
import { getManufacturerLists } from '@/api/deviceBrand/deviceBrandFactory'
import { delBrandModel, getBrandLists, getBrandOption } from '@/api/deviceBrand/deviceBrand'
import FormsDialog from './components/forms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImportsForm from '@/components/ImportsForm.vue'
// import EquiType from './components/type.vue'
const formVisible = ref(true)
// 重置
const resetQueryForm = () => {
    Object.keys(queryForms.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size') queryForms.value[key] = ''
    })
}
// 数据源
const queryForms = ref({
    name: '',
    page: 1,
    page_size: 10
})
const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 品牌下拉选项
const brandOptionList = ref([])
// const brandOptionObj = ref(null)
const getCommunicationTypeFun = async () => {
    const res = await getBrandOption()
    brandOptionList.value = res
}
getCommunicationTypeFun()

// 设备品牌选项列表、厂家选项列表
const manufacturerLists = ref([])
const manufacturerObj = ref({})
const manufacturerOptionLists = ref([])
// const manufacturerOptionObj = ref([])
const getManufacturerListsData = async () => {
    const res = await getManufacturerLists()
    manufacturerLists.value = res
    const optionObj = {}
    res.forEach((item) => {
        optionObj[item.id] = item.name
    })
    manufacturerObj.value = optionObj
}

getManufacturerListsData()

// 获取列表数据
const getTableData = async () => {
    tableLoading.value = true
    const result = await getBrandLists(queryForms.value)
    //  刷新品牌选项
    getCommunicationTypeFun()
    table_data.value = result.lists
    total.value = result.total
    tableLoading.value = false
}

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    queryForms.value.page_size = currentSize
    getTableData()
}
// page 页码改变触发
const handleCurrentChange = (currentPage) => {
    queryForms.value.page = currentPage
    getTableData()
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModelId = ref('') // 点中的模块id
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectModelId.value = ''
})

// 查看
const onShowClick = (row) => {
    isForm.value = false
    if (row.pid == null) {
        selectModelId.value = row.id
        formDialogVisible.value = true
    } else {
        selectModelId.value = row.pid
    }
}
// 编辑
const onEditClick = (row) => {
    isForm.value = true
    if (row.pid == null) {
        selectModelId.value = row.id
        formDialogVisible.value = true
    } else {
        selectModelId.value = row.pid
    }
}
// 添加
const onAddClick = () => {
    selectModelId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}

// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            if (row.pid == null) {
                await delBrandModel(row.id)
            } else {
                // await delSuper(row.id)
            }
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}

const uploadVisible = ref(false)
// 导出
const handleExport = async () => {
    ElMessageBox.confirm('您确定导出全部型号及类别吗？', {
        type: 'warning'
    })
        .then(async () => {
            const { data } = await getBrandLists({ ...queryForms.value, export: 1 })
            window.open(data)
            ElMessage.success('导出成功')
        })
        .catch(() => {})
}

// 切换到前台时候执行
onMounted(() => {
    getTableData()
})
</script>

<style scoped></style>
